// API functions for SearchMapping management

export const fetchSearchMappings = async (axiosPrivate) => {
    try {
        const response = await axiosPrivate.get("/admin/search-mapping");
        return response.data.data;
    } catch (error) {
        console.error("Error fetching search mappings:", error);
        throw error;
    }
};

export const updateSearchMapping = async (axiosPrivate, id, data) => {
    try {
        const response = await axiosPrivate.put(`/admin/search-mapping/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating search mapping:", error);
        throw error;
    }
};

export const normalizeSearchMappings = async (axiosPrivate) => {
    try {
        const response = await axiosPrivate.post("/admin/search-mapping/normalize");
        return response.data;
    } catch (error) {
        console.error("Error normalizing search mappings:", error);
        throw error;
    }
};

export const resetSearchMappings = async (axiosPrivate) => {
    try {
        const response = await axiosPrivate.post("/admin/search-mapping/reset");
        return response.data;
    } catch (error) {
        console.error("Error resetting search mappings:", error);
        throw error;
    }
};
